export const getSherpaConfig = () => ({
  scriptURL: process.env.REACT_APP_SHERPA_SCRIPT_URL,
  appID: process.env.REACT_APP_SHERPA_APP_ID
});
